import axios, { getData } from 'lib/axios'

export const retrieveExcludedEmployees = async () => {
  const res = await axios.get(`admin/payroll_exclude`).then(getData)
  return res
}
export const retrieveIncludedEmployees = async () => {
  const res = await axios.get(`admin/payroll_include`).then(getData)
  return res
}

export const excludeSelectedEmployee = (data) => {
  return axios.post(`admin/payroll_exclude`, data)
}

export const removeExcludedEmployee = (employee_id) => {
  return axios.delete(`admin/payroll_exclude/${employee_id}`)
}

export const addEmployeeToPayroll = (time_id, employee_id) => {
  return axios.post(`admin/payroll/${time_id}/employee/${employee_id}/include`)
}

export const removeEmployeeFromPayroll = (time_id, employee_id) => {
  return axios.delete(`admin/payroll/${time_id}/employee/${employee_id}`)
}